/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelDataEntryCustomIndicator'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForecastModelDataEntryCustomIndicator'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelDataEntryCustomIndicatorApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelDataEntryCustomIndicator);
  }
}(this, function(ApiClient, ForecastModelDataEntryCustomIndicator) {
  'use strict';

  /**
   * ForecastModelDataEntryCustomIndicator service.
   * @module api/ForecastModelDataEntryCustomIndicatorApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForecastModelDataEntryCustomIndicatorApi. 
   * @alias module:api/ForecastModelDataEntryCustomIndicatorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the forecastModelDataEntryCustomIndicatorAddAllPut operation.
     * @callback module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ForecastModelDataEntryCustomIndicator>} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withNotifications  (default to false)
     * @param {module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.forecastModelDataEntryCustomIndicatorAddAllPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryCustomIndicatorAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryCustomIndicatorAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'withNotifications': opts['withNotifications']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/ForecastModelDataEntryCustomIndicator/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryCustomIndicatorAddPut operation.
     * @callback module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelDataEntryCustomIndicator} body 
     * @param {module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.forecastModelDataEntryCustomIndicatorAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryCustomIndicatorAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryCustomIndicatorAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForecastModelDataEntryCustomIndicator/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryCustomIndicatorDeleteAllPut operation.
     * @callback module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryCustomIndicatorDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryCustomIndicatorDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryCustomIndicatorDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntryCustomIndicator/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryCustomIndicatorDeleteGet operation.
     * @callback module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryIndicatorID 
     * @param {module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryCustomIndicatorDeleteGet = function(_4SAPIAppID, entryIndicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryCustomIndicatorDeleteGet";
      }

      // verify the required parameter 'entryIndicatorID' is set
      if (entryIndicatorID == undefined || entryIndicatorID == null) {
        throw "Missing the required parameter 'entryIndicatorID' when calling forecastModelDataEntryCustomIndicatorDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryIndicatorID': entryIndicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntryCustomIndicator/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryCustomIndicatorLoadGet operation.
     * @callback module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelDataEntryCustomIndicator} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryIndicatorID 
     * @param {module:api/ForecastModelDataEntryCustomIndicatorApi~forecastModelDataEntryCustomIndicatorLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelDataEntryCustomIndicator}
     */
    this.forecastModelDataEntryCustomIndicatorLoadGet = function(_4SAPIAppID, entryIndicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryCustomIndicatorLoadGet";
      }

      // verify the required parameter 'entryIndicatorID' is set
      if (entryIndicatorID == undefined || entryIndicatorID == null) {
        throw "Missing the required parameter 'entryIndicatorID' when calling forecastModelDataEntryCustomIndicatorLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryIndicatorID': entryIndicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelDataEntryCustomIndicator;

      return this.apiClient.callApi(
        '/ForecastModelDataEntryCustomIndicator/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
